import { render, staticRenderFns } from "./PatientSidebar.vue?vue&type=template&id=4c40157c&scoped=true"
import script from "./PatientSidebar.vue?vue&type=script&lang=js"
export * from "./PatientSidebar.vue?vue&type=script&lang=js"
import style0 from "./PatientSidebar.vue?vue&type=style&index=0&id=4c40157c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c40157c",
  null
  
)

export default component.exports